module.exports = __webpack_public_path__ + "static/TABLERODE CONTROL-d36dde3e8bf4fff11877d881ff5d5e0d.webp";